<template>
  <q-card>
    <div
      class="text-body1 text-bold q-px-sm"
      :class="$q.dark.mode ? 'text-grey-2' : 'text-primary'"
    >
      Price Action Signal
    </div>

    <ListCardTableViewTradingView
      :tableTitle="'Price Action Signal Status'"
      :timePeriod="timePeriod"
      :buttonBuyOrSell="buttonBuyOrSell"
      :buyData="priceActionSignalDataComputed"
      :sellData="priceActionSignalSellDataComputed"
      :alertOrSignal="'signal'"
      @selectedSymbol="(s) => (symbolSelected = s)"
    />
  </q-card>
</template>

<script setup>
import { ref, onMounted, watch, computed } from "vue";
import { useQuasar } from "quasar";

import useData from "src/use/data";

import ListCardTableViewTradingView from "src/components/TradingSignalsAndType/StockWiseListCardTableViewTradingView.vue";

const props = defineProps({
  symbol: {
    type: String,
  },
  timePeriod: {
    type: String,
  },
  buttonBuyOrSell: {
    type: String,
  },
});
const {
  priceActionSignalDaily,
  priceActionSignalSellDaily,
  priceActionSignalHourly,
  priceActionSignalSellHourly,
  priceActionSignalWeekly,
  priceActionSignalSellWeekly,
} = useData();

const $q = useQuasar();

const symbolSelected = ref(null);

const priceActionSignalData = ref([]);
const priceActionSignalSellData = ref([]);

async function loadData(apiFunction, dataValue) {
  $q.loading.show({});
  try {
    const res = await apiFunction(365);
    dataValue.value = res.data;
  } catch (error) {
    console.error("Error loading data:", error);
  } finally {
    $q.loading.hide();
  }
}

function updateDataBasedOnTimePeriod(timePeriodValue) {
  if (timePeriodValue === "daily") {
    loadData(priceActionSignalDaily, priceActionSignalData);
    loadData(priceActionSignalSellDaily, priceActionSignalSellData);
  } else if (timePeriodValue === "hourly") {
    loadData(priceActionSignalHourly, priceActionSignalData);
    loadData(priceActionSignalSellHourly, priceActionSignalSellData);
  } else if (timePeriodValue === "weekly") {
    loadData(priceActionSignalWeekly, priceActionSignalData);
    loadData(priceActionSignalSellWeekly, priceActionSignalSellData);
  }
}

const priceActionSignalDataComputed = computed(() => {
  return priceActionSignalData.value.filter(
    (item) => item.symbol === props.symbol
  );
});

const priceActionSignalSellDataComputed = computed(() => {
  return priceActionSignalSellData.value.filter(
    (item) => item.symbol === props.symbol
  );
});

watch(
  () => props.timePeriod,
  (newVal, oldVal) => {
    updateDataBasedOnTimePeriod(newVal);
  }
);

onMounted(() => {
  updateDataBasedOnTimePeriod(props.timePeriod);
});
</script>
